<template>
  <div class="block h-full absolute top-0 left-0 w-full  overflow-y-scroll">
    <h1 class="heading text-3xl">Puzzle: {{ number }}</h1>
    <h3 v-if="startTime > 0" class="text-2xl font-main my-2 h-10">
      Time<span v-if="countdown"> Remaining</span>:
      <span class="h-10 ">{{ time }}</span>
    </h3>
    <div class="md:px-6 image">
      <img v-show="imageLoaded" id="image" alt="Map Problem" height="500px" />
      <h1 v-if="!imageLoaded" class="heading text-xl">Image Loading</h1>
    </div>

    <p
      v-if="description && imageLoaded"
      class="font-main font-semibold text-xl my-6"
    >
      {{ description }}
    </p>

    <div v-if="startTime > 0" class="choices mt-2">
      <button
        v-for="button of options"
        :key="button"
        class="button"
        :class="{ large: largeButtons }"
        @click="selectChoice(button)"
      >
        {{ button }}
      </button>
    </div>
    <button
      v-if="startTime > 0 && !hideSkip"
      class="button skip white"
      @click="selectChoice(0)"
    >
      Skip
    </button>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [1, 2, 3],
    },
    keyboard: {
      type: Boolean,
      default: true,
    },
    beep5: {
      type: Boolean,
      default: false,
    },
    beepCountdown: {
      type: Boolean,
      default: false,
    },
    countdown: {
      type: Boolean,
      default: true,
    },
    largeButtons: {
      type: Boolean,
      default: false,
    },
    startingTime: {
      type: Number,
      default: 20,
    },
    description: {
      type: String,
      default: '',
    },
    hideSkip: {
      type: Boolean,
      default: false,
    },
  },

  data: function() {
    return {
      audio: undefined,
      time: 0,
      startTime: 0,
      interval: [],
      imageLoaded: false,
      beeped: '',
    }
  },

  mounted: function() {
    if (window.AudioContext) this.audio = new AudioContext()

    const vue = this
    if (this.keyboard)
      document.addEventListener('keydown', function(event) {
        const oneKey = [35, 49, 97]
        const twoKey = [40, 50, 98]
        const threeKey = [34, 51, 99]

        if (oneKey.includes(event.keyCode)) vue.selectChoice(1)
        if (twoKey.includes(event.keyCode)) vue.selectChoice(2)
        if (threeKey.includes(event.keyCode)) vue.selectChoice(3)
      })

    const image = document.getElementById('image')
    image.onload = this.startTimer
    image.src = this.name
    image.onerror = async event => {
      const image = document.getElementById('image')
      await this.delay(1000)
      const source = image.src
      image.src = source
    }
  },

  methods: {
    delay: function(time) {
      return new Promise(resolve => setTimeout(resolve, time))
    },

    tick: function() {
      if (this.countdown) this.time -= 1
      else this.time += 1

      if (this.time <= 0) this.timeOver()

      if (this.time % 5 === 0 && this.beep5 && this.time !== 0)
        this.beep(50, 520, 500, this.time)

      if (this.beepCountdown && [1, 2, 3, 5].includes(this.time))
        this.beep(50, 520, 500, this.time)
    },

    startTimer: function() {
      this.imageLoaded = true

      if (this.countdown) this.time = this.startingTime
      else this.time = 0

      this.startTime = Date.now()

      const tickFunction = this.tick
      this.interval = setInterval(tickFunction, 1000)
    },

    clearTimer: function() {
      clearInterval(this.interval)
    },

    timeOver: function() {
      this.selectChoice(0)
    },

    selectChoice: function(choice) {
      const time = Date.now() - this.startTime
      this.clearTimer()

      this.$emit('complete', { choice: choice, time: time })
    },

    beep: function(vol, freq, duration, type) {
      if (type === this.beeped || !this.audio) return
      this.beeped = type

      navigator.vibrate(500)

      const oscillator = this.audio.createOscillator()
      const gain = this.audio.createGain()
      oscillator.connect(gain)
      oscillator.frequency.value = freq
      oscillator.type = 'square'
      gain.connect(this.audio.destination)
      gain.gain.value = vol * 0.01
      oscillator.start(this.audio.currentTime)
      oscillator.stop(this.audio.currentTime + duration * 0.001)
    },
  },
}
</script>

<style lang="postcss">
.image img {
  width: 100%;
  height: auto;
  object-fit: cover;
  @apply inline-block;
}

@media (min-width: 768px) {
  .image img {
    width: 80%;
    margin-left: 10%;
  }
}

.image {
  @apply flex flex-col justify-center content-center;
  min-height: 300px;
}

@media (min-width: 1000px) {
  .image {
    width: 80%;
    margin-left: 10%;
  }
}

@media (min-width: 1200px) {
  .image {
    width: 70%;
    margin-left: 15%;
  }
}

@media (min-width: 1450px) {
  .image {
    width: 60%;
    margin-left: 20%;
  }
}
</style>
